import React, { Fragment } from 'react'
import { host } from '../../../../../configuraciones';
import axios from 'axios'
import ModalMensajeComponent from './ModalMensajeComponent';
import { useSelector } from 'react-redux'

function BotonVerArchivoComponent(props) {
    
    const dataUser = useSelector(store => store.Usuario.user)

    const { tabla, nombreId, idSolicitud, nameid } = props
    const [openModal, setOpenModal] = React.useState(false)
    const verArchivo = async () => {
        const fileFetch = await fetch(host + `FC_01/servirArchivo/tabla=${tabla}&nombreId=${nombreId}&idSolicitud=${idSolicitud}&nameid=${nameid}`)

        if (fileFetch.status != 404) {
            const blob = await fileFetch.blob();
            const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
            window.open(url);
        } else {
            setOpenModal(true)
        }
    }

    return (
        <Fragment>
            <button onClick={() => verArchivo()} className='btn btn-outline-success' disabled={dataUser?.[0]?.idtipousuario != 10}>Ver</button>
            { openModal &&
                <ModalMensajeComponent setOpenModal={{ setOpenModal }} titleModal={'Error'} bodyModal={'No hay archivos adjuntos'}></ModalMensajeComponent>
            }
        </Fragment>
    )
}

export default BotonVerArchivoComponent